//import fetch from "auth/FetchInterceptor";
// import {lossClient, collateralClient} from "api";
// import fetch from "auth/FetchInterceptor";
// import { lossClient,lmsClient } from "api";
import { lossClient, collateralClient, lmsClient } from "api";

const referenceService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

referenceService.getSupplierTypeList = function (data) {
  return lossClient({
    url: "/reference/suppliertype",
    method: "get",
  });
};

referenceService.getSupplierCategoryList = function (data) {
  return lossClient({
    url: "/reference/suppliercategory",
    method: "get",
  });
};

referenceService.getSupplierStatusList = function (data) {
  return lossClient({
    url: "/reference/supplierstatus",
    method: "get",
  });
};

referenceService.getAgencyTypeList = function (data) {
  return lossClient({
    url: "/reference/agencytype",
    method: "get",
  });
};

referenceService.getAgencyCategoryList = function (data) {
  return lossClient({
    url: "/reference/agencycategory",
    method: "get",
  });
};

referenceService.getAgencyStatusList = function (data) {
  return lossClient({
    url: "/reference/agencyStatus",
    method: "get",
  });
};

referenceService.getAgencyEmployeePositionList = function (data) {
  return lossClient({
    url: "/reference/agencyemployeeposition",
    method: "get",
  });
};

referenceService.getBranchList = function (data) {
  return lossClient({
    url: `/branchorg/search?pageSize=10000&pageIndex=0${
      data && data.branchId ? `&branchId=${data.branchId}` : ""
    }`,
    method: "get",
  });
};

referenceService.getGenderList = function (data) {
  return lossClient({
    url: `/reference/gender`,
    method: "get",
  });
};

referenceService.getIdTypeList = function (data) {
  return lossClient({
    url: `/reference/idtype`,
    method: "get",
  });
};

referenceService.getAddressTypeList = function (data) {
  return lossClient({
    url: `/reference/addresstype`,
    method: "get",
  });
};

referenceService.getMaritalStatusList = function (data) {
  return lossClient({
    url: `/reference/maritalstatus`,
    method: "get",
  });
};

referenceService.getNationalityList = function (data) {
  return lossClient({
    url: `/reference/nationality`,
    method: "get",
  });
};

referenceService.getCustomerTypeList = function (data) {
  return lossClient({
    url: `/reference/customertype`,
    method: "get",
  });
};

referenceService.getPersonalCustomerTypeList = function (data) {
  return lossClient({
    url: `/reference/personalcustomertype`,
    method: "get",
  });
};

referenceService.getCustomerStatusList = function (data) {
  return lossClient({
    url: `/reference/CustomerStatus`,
    method: "get",
  });
};

referenceService.getSourceApplicationList = function (data) {
  return lossClient({
    url: `/reference/sourceapplication`,
    method: "get",
  });
};

referenceService.getCurrencyList = function (data) {
  return lossClient({
    url: `/Currency/items?pageSize=1000&pageIndex=0`,
    method: "get",
  });
};

referenceService.getAcquisitionTypeList = function (data) {
  return lossClient({
    url: `/reference/AcquisitionType`,
    method: "get",
  });
};

referenceService.getProspectStepList = function (data) {
  return lossClient({
    url: `/reference/ProspectStep`,
    method: "get",
  });
};

referenceService.getScreeningDecisionList = function (data) {
  return lossClient({
    url: `/reference/screeningdecision`,
    method: "get",
  });
};

referenceService.getReasonList = function (data) {
  return lossClient({
    url: `/reference/reason?reasontypeid=` + data.reasontypeid,
    method: "get",
  });
};

referenceService.getHomeLocationList = function (data) {
  return lossClient({
    url: `/reference/homelocation?code=` + data?.code,
    method: "get",
  });
};

//Belongs To Santani
referenceService.interestType = function (data) {
  return lossClient({
    url: "/reference/interestType",
    method: "get",
  });
};

referenceService.assetType = function (data) {
  console.log("🚀 ~ dataassetType:", data);
  return lossClient({
    url: "/AssetType/Items",
    method: "get",
  });
};

referenceService.financeScheme = function (data) {
  // console.log("🚀 ~ datafinanceSchemeList:", data);
  return lossClient({
    url: "/reference/financescheme",
    method: "get",
  });
};

referenceService.idType = function (data) {
  console.log("🚀 ~ dataidTypeList:", data);
  return lossClient({
    url: "/reference/idType",
    method: "get",
  });
};

referenceService.SelectGender = function (data) {
  console.log("🚀 ~ dataidTypeList:", data);
  return lossClient({
    url: "/reference/gender",
    method: "get",
  });
};

referenceService.SupplierStatus = function (data) {
  console.log("🚀 ~ dataSelectSupplierStatusSliceservice:", data);
  return lossClient({
    url: "/reference/supplierstatus",
    method: "get",
  });
};

referenceService.SupplierCategory = function (data) {
  console.log("🚀 ~ dataSelectSupplierCategorySliceservice:", data);
  return lossClient({
    url: "/reference/suppliercategory",
    method: "get",
  });
};

referenceService.SelectApplicationType = function (data) {
  // console.log("🚀ss ~ dataSelectSupplierCategorySliceservice:", data);
  return lossClient({
    url: "/reference/applicationtype",
    method: "get",
  });
};

referenceService.SelectEventPromo = function (data) {
  return lossClient({
    url: "/reference/eventpromo",
    method: "get",
  });
};

referenceService.SelectSourceApplication = function (data) {
  return lossClient({
    url: "/reference/sourceapplication",
    method: "get",
  });
};

referenceService.getFinanceType = function (data) {
  return lossClient({
    url: "/reference/financetype",
    method: "get",
  });
};

referenceService.SelectMasterBank = function (data) {
  return lossClient({
    url: "/reference/masterBankId",
    method: "get",
  });
};

referenceService.getLineofBusinessList = function (data) {
  return lossClient({
    url: "/reference/lineofbusiness",
    method: "get",
  });
};

referenceService.SelectMasterBankSearch = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/masterbank/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&searchTerm=" +
      userInput.searchTerm,
    method: "get",
  });
};
referenceService.SelectCustomer = function (userInput) {
  console.log("🚀 ~ userInputSelectCustomer:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/PersonalCustomerSpouse/personalcustomerspouses?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

referenceService.SearchCustomerByNameAndAddress = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/Customer/lookup?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&name=" +
      userInput.name +
      "&alamat=" +
      userInput.address,
    method: "get",
  });
};

referenceService.SelectWayOfPaymentService = function (userInput) {
  return lossClient({
    url: "/reference/wayofpayment",
    method: "get",
  });
};

referenceService.GetRojksegmenfasilitas = function (userInput) { 
  return lossClient({
    url: "/reference/rojksegmenfasilitas",
    method: "get",
  });
};

referenceService.GetAssetGrade = function () {
  return lossClient({
    url: "/reference/assetgrade",
    method: "get",
  });
};

referenceService.GetServiceType = function () {
  return lossClient({
    url: "/reference/servicetype",
    method: "get",
  });
};

referenceService.GetInterestScheme = function () {
  return lossClient({
    url: "/reference/interestscheme",
    method: "get",
  });
};

referenceService.GetInterestCalcMethod = function () {
  return lossClient({
    url: "/reference/interestcalcmethod",
    method: "get",
  });
};

referenceService.GetInstallMentScheme = function () {
  return lossClient({
    url: "/reference/installmentscheme",
    method: "get",
  });
};

referenceService.GetInsPaidBy = function () {
  return lossClient({
    url: "/reference/InsPaidBy",
    method: "get",
  });
};

referenceService.productDocument = function (data) {
  return lossClient({
    url: "/reference/productDocument",
    method: "get",
  });
};

referenceService.GetInterestRateOffer = function () {
  return lossClient({
    url: "/reference/interestrateoffer",
    method: "get",
  });
};

referenceService.GetPaymentfrequency = function () {
  return lossClient({
    url: "/reference/paymentfrequency",
    method: "get",
  });
};

referenceService.GetDayMonth = function () {
  return lossClient({
    url: "/reference/daymonth",
    method: "get",
  });
};

referenceService.GetAssetCondition = function () {
  return lossClient({
    url: "/reference/assetcondition",
    method: "get",
  });
};

referenceService.GetSurveyType = function () {
  return lossClient({
    url: "/reference/surveytype",
    method: "get",
  });
};

referenceService.GetPenggunaanDanaTunai = function (data) {
  return lossClient({
    url: "/reference/penggunaandanatunai",
    method: "get",
  });
};

referenceService.GetInsCoverageType = function () {
  return lossClient({
    url: "/reference/InsCoverageType",
    method: "get",
  });
};

referenceService.GetInsCoverBy = function () {
  return lossClient({
    url: "/reference/InsCoverBy",
    method: "get",
  });
};

referenceService.GetFirstinstallment = function () {
  return lossClient({
    url: "/reference/firstinstallment",
    method: "get",
  });
};

referenceService.GetInterestcalcmethod = function () {
  return lossClient({
    url: "/reference/interestcalcmethod",
    method: "get",
  });
};

referenceService.GetKodePekerjaan = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/reference/kodepekerjaanid?ageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput?.code +
      "&description=" +
      userInput?.description,
    method: "get",
  });
};

referenceService.GetEmployePosition = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/reference/employeeposition?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput?.code +
      "&name=" +
      userInput?.name,
    method: "get",
  });
};

referenceService.GetAgencyemployeepositionService = function (data) {
  return lossClient({
    url: `/reference/agencyemployeeposition`,
    method: "get",
  });
};

referenceService.getTaxIdList = function (data) {
  return lossClient({
    url: "/reference/taxID",
    method: "get",
  });
};

referenceService.OptionCollAmountService = function (userInput) {
  return lossClient({
    url: "/reference/OptionCollAmount",
    method: "get",
  });
};

referenceService.CollateralStatusService = function (userInput) {
  return lossClient({
    url: "/reference/CollateralStatus",
    method: "get",
  });
};

referenceService.getRcvFromCollateral = function () {
  return collateralClient({
    url: "/Reference/code/COLLTRANID",
    method: "get",
  });
};

referenceService.GetRojkcategorydebitur = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/reference/rojkcategorydebitur?ageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput?.code,
    method: "get",
  });
};

referenceService.GetRepaymentTypeService = function (userInput) {
  return lossClient({
    url: "/reference/RepaymentType",
    method: "get",
  });
};

referenceService.GetStatusrumahService = function (userInput) {
  return lossClient({
    url: "/reference/statusrumah",
    method: "get",
  });
};

referenceService.GetROJKKreditPemerintahService = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/reference/ROJKKreditPemerintah?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

referenceService.GetApprovalStepService = function (userInput) {
  return lossClient({
    url: "/reference/ApprovalStep",
    method: "get",
  });
};

referenceService.GetStepupstepdowntypeService = function (userInput) {
  return lossClient({
    url: "/reference/stepupstepdowntype",
    method: "get",
  });
};

referenceService.GetDownPaymentPaidService = function (userInput) {
  return lossClient({
    url: "/reference/downPaymentPaid",
    method: "get",
  });
};

referenceService.GetTipepencairanService = function (userInput) {
  return lossClient({
    url: "/reference/tipepencairan",
    method: "get",
  });
};

referenceService.GetDisbursementToService = function (userInput) {
  return lossClient({
    url: "/reference/disbursementto",
    method: "get",
  });
};

referenceService.GetUsagePolicyService = function (userInput) {
  return lossClient({
    url: "/reference/UsagePolicy",
    method: "get",
  });
};

referenceService.GetcodePlatService = function (userInput) {
  return lossClient({
    url: "/reference/kodePlat",
    method: "get",
  });
};

referenceService.GetSystemDateService = function (userInput) {
  return lossClient({
    url: "/reference/systemDate",
    method: "get",
  });
};

referenceService.GetKaroseriTypesService = function (userInput) {
  return lossClient({
    url: "/reference/karoseriTypes",
    method: "get",
  });
};

referenceService.GetPeriodCoverService = function (userInput) {
  return lossClient({
    url: "/reference/InsCoverPeriod",
    method: "get",
  });
};

referenceService.GetGraceperiodtypeService = function (userInput) {
  return lossClient({
    url: "/reference/graceperiodtype",
    method: "get",
  });
};

referenceService.GetSurveyLocationService = function (userInput) {
  return lossClient({
    url: "/reference/surveyLocation",
    method: "get",
  });
};

referenceService.GetCheckSocialAspectService = function (userInput) {
  return lossClient({
    url: "/reference/CheckSocialAspect",
    method: "get",
  });
};

referenceService.GetRelationWithSalesService = function (userInput) {
  return lossClient({
    url: "/reference/RelationWithSales",
    method: "get",
  });
};

referenceService.GetBusinessAddressFlagService = function (userInput) {
  return lossClient({
    url: "/reference/BusinessAddressFlag",
    method: "get",
  });
};

referenceService.GetBpkbIssuedByService = function (userInput) {
  return lossClient({
    url: "/reference/bpkbissuedBy",
    method: "get",
  });
};

referenceService.GetHomeConditionService = function (userInput) {
  return lossClient({
    url: "/reference/homeCondition",
    method: "get",
  });
};

referenceService.GetHomeFurnishingsService = function (userInput) {
  return lossClient({
    url: "/reference/homefurnishings",
    method: "get",
  });
};

referenceService.GetRoadConditionHomeService = function (userInput) {
  return lossClient({
    url: "/reference/roadConditionHome",
    method: "get",
  });
};

referenceService.GetEnvironmentalConditionsService = function (userInput) {
  return lossClient({
    url: "/reference/EnvironmentalConditions",
    method: "get",
  });
};

referenceService.GetOfficeLocationService = function (userInput) {
  return lossClient({
    url: "/reference/officeLocation",
    method: "get",
  });
};

referenceService.GetBankIdService = function (userInput) {
  return lossClient({
    url: "/reference/bankid",
    method: "get",
  });
};

referenceService.GetaccountTypeService = function (userInput) {
  return lossClient({
    url: "/reference/accountType",
    method: "get",
  });
};

referenceService.getDocumentStatus = function (data) {
  return collateralClient({
    url: "/Reference/code/ASSETDOCSTATUS",
    method: "get",
  });
};

referenceService.GetRefLoanAssessmentItemValueService = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  const params = {
    pageSize: userInput.pageSize,
    pageIndex: decrementIndex,
    lineOfBusiness: userInput?.lineOfBusiness,
    productId: userInput?.productId,
    groupId: userInput?.groupId,
  };
  return lossClient({
    url: `/RefLoanAssessmentItemValue/search?${buildQuery(params)}`,
    method: "get",
  });
};

referenceService.GetCarecomendationService = function (userInput) {
  return lossClient({
    url: "/reference/carecomendation",
    method: "get",
  });
}; 

// LMS ReferenceService
referenceService.getRefInvoiceDisbDoc = function (data) {
  return lmsClient({
    url: "/lms/reference/refInvoiceDisbDoc",
    method: "get",
  });
};
referenceService.getPaymentTerm = function (data) {
  return lmsClient({
    url: "/lms/reference/paymentTerm",
    method: "get",
  });
};

referenceService.getBankAccountType = function (data) {
  return lmsClient({
    url: "/lms/reference/bankaccounttype",
    method: "get",
  });
};

referenceService.getAccountPurpose = function (data) {
  return lmsClient({
    url: "/lms/reference/accountpurpose",
    method: "get",
  });
};

referenceService.getEBankingConnect = function (data) {
  return lmsClient({
    url: "/lms/reference/ebankingconnect",
    method: "get",
  });
};

referenceService.getResetFlag = function (data) {
  return lmsClient({
    url: "/lms/reference/resetflag",
    method: "get",
  });
};

export default referenceService;
